<template>
    <div class="form-inline">
        <div class="form-group mb-2">
            <label for="filename" class="form-label mr-2">Export As:</label>
            <input type="text" class="form-control form-control-sm" id="filename" v-model="fileName" placeholder="Enter filename">
        </div>
        <div class="form-group mx-sm-3 mb-2">
            <span>.CSV</span>
        </div>
        <button class="btn btn-primary btn-sm" @click="handleExportClick">{{exportButtonText}}</button>
    </div>
</template>

<script>
export default {
  name: 'DataListCSV',
  props: {
    dataCols: Array,
    dataListItems: Array,
    selectedItems: Array
  },
  data: () => {
    return {
        fileName: null
    }
  },
  mounted() {
      this.fileName = this.idName
  },
  watch: {
      
  },
  computed: {
      idName() {
          var now = new Date().getTime();
          return "export_" + now;
      },
      exportButtonText() {
          let recordCount = this.dataListItems ? this.dataListItems.length : 0
          if (this.selectedItems && this.selectedItems.length > 0) {
              recordCount = this.selectedItems.length
          }

          return `Export (${recordCount} records)`
      }
  },
  methods: {
    handleExportClick() {
        let csvContent = new Blob([this.getCSV()])
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(csvContent, { type: "text/plain" })
        link.download = this.fileName ? this.fileName + ".csv" : this.idName + ".csv"
        link.click()
    },
    getCSV() {
        let csvData = []
        this.dataCols.forEach(c =>
        {
            csvData.push(c.display)
            csvData.push(',')
        })
        csvData.pop()
        csvData.push("\r\n")

        this.dataListItems.map(item =>
        {
            if (this.selectedItems && this.selectedItems.length > 0) {
                if (!this.selectedItems.includes(item)) {
                    return
                }
            }

            this.dataCols.forEach(c =>
            {
                let escapedCSV = '=\"' + item[c.key] + '\"'
                if (escapedCSV.match(/[,"\n]/)) {
                    escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"'
                }
                csvData.push(escapedCSV)
                csvData.push(",")
            })
            csvData.pop()
            csvData.push("\r\n")
        })

        csvData.pop()
        csvData.push("\r\n")
        return csvData.join("")
    }
  }
}
</script>

<style scoped>
</style>
